import { render, staticRenderFns } from "./CompetitionDetail.vue?vue&type=template&id=31a584b9&scoped=true&"
import script from "./CompetitionDetail.vue?vue&type=script&lang=js&"
export * from "./CompetitionDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a584b9",
  null
  
)

export default component.exports